// @ts-ignore
import * as jstat from 'jstat';


// various functions to generate 400 datapoints for the graph depending on user's choice of input
export function normalDataSet(mean: number, std: number) {
  // Handle case where std goes to 0

  let min = mean - 3 * std;
  min = min > 0 ? min : 0;

  let max = mean + 3 * std;
  max = max > 0 ? max : 1;
  max = max <= 5000000 ? max : 5000000;

  let increment = 1;
  const range = max - min;
  if (range === 0) {
    increment = 0.01;
  } else {
    increment = range / 400;
  }

  // Generate PDF
  const data = [];
  for (let i = mean - 4 * std; i <= mean + 4 * std; i += increment) {
    const el = {
      x: i,
      y: jstat.normal.pdf(i, mean, std),
    };
    data.push(el);
  }
  return data;
}

export function deterministicDataSet(mean: number) {
  const data = [];
  for (let i = 0; i <= 400; i++) {
    const el = {
      x: i,
      y: mean * i,
    };
    data.push(el);
  }
  return data;
}

export function uniformDataSet(min: number, max: number) {
  const data = [{
    x: 0,
    y: 0,
  }, {
    x: min,
    y: 0,
  }];

  let increment = 1;
  const range = max - min;
  if (range === 0) {
    increment = 0.01;
  } else {
    increment = range / 400;
  }

  for (let i = min; i <= max; i += increment) {
    const el = {
      x: i,
      y: jstat.uniform.pdf(i, min, max),
    };
    data.push(el);
  }
  data.push({
    x: max,
    y: 0,
  }, {
    x: max + 5,
    y: 0,
  });
  return data;
}

export function logNormalDataSet(location: number, shape: number) {

  // let min = Math.exp(mean - 3 * std);
  // min = min > 0 ? min : 0;
  const min = 0;
  
  let max = Math.exp(location + 3 * shape);
  max = max <= 5000000 ? max : 5000000;
  
  const increment = (max - min) / 400;
  
  console.log('log increment', increment);

  const data = [];
  for (let i = min; i <= max; i += (increment)) {
    const el = {
      x: i,
      y: jstat.lognormal.pdf(i, location, shape),
    };
    data.push(el);
  }
  return data;
}

export function triangularDataSet(min: number, max: number, mode: number) {
  const data = [];

  let increment = 1;
  const range = max - min;
  if (range === 0) {
    increment = 0.01;
  } else {
    increment = range / 400;
  }

  for (let i = min; i <= max; i += increment) {
    const el = {
      x: i,
      y: jstat.triangular.pdf(i, min, max, mode),
    };
    data.push(el);
  }
  return data;
}

export function truncatedNormalDataSet(mean: number, std: number, min: number, max: number) {
  const data = [{
    x: min,
    y: 0,
  }];

  let increment = 1;
  const range = max - min;
  if (range === 0) {
    increment = 0.01;
  } else {
    increment = range / 400;
  }

  for (let i = min; i <= max; i += increment) {
    const el = {
      x: i,
      y: jstat.normal.pdf(i, mean, std),
    };
    data.push(el);
  }
  // data.push({
  //   "x": max,
  //   "y": 0
  // }, {
  //   "x": max + 5,
  //   "y": 0
  // });
  return data;
}

export function truncatedLogNormalDataSet(location: number, shape: number, min: number, max: number) {
  const data = [{
    x: min,
    y: 0,
  }];


  let increment = 1;
  const range = max - min;
  if (range === 0) {
    increment = 0.01;
  } else {
    increment = range / 400;
  }

  for (let i = min; i <= max; i += increment) {
    const el = {
      x: i,
      y: jstat.lognormal.pdf(i, location, shape),
    };
    data.push(el);
  }
  data.push({
    x: max,
    y: 0,
  }, {
    x: max + 5,
    y: 0,
  });
  return data;
}
